// extracted by mini-css-extract-plugin
export default {"table":"AssemblyTable_table__-kjDZ","completed":"AssemblyTable_completed__qk97P","inProgress":"AssemblyTable_inProgress__MZkBB","pending":"AssemblyTable_pending__TYnZY"};